import { useEffect } from "react";

const LoginBasePage = (props: any) => {
  useEffect(() => {
    window.document.title = "OMS - Login";
  }, []);
  return <div className="wrapper">{props.children}</div>;
};

export default LoginBasePage;
